import Svg, { Path } from 'react-native-svg';

const LocationIcon = ({ width, height }) => (
  <Svg
    width={width}
    height={height}
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <Path
      d="M8 0C4.89681 0 2.375 2.36426 2.375 5.27344C2.375 6.25781 2.66569 7.21585 3.21878 8.04202L7.61869 14.7924C7.69375 14.9067 7.80625 14.977 7.93753 14.9946C8.11559 15.0209 8.31256 14.9507 8.41566 14.7837L12.8282 7.97168C13.3531 7.16312 13.625 6.22269 13.625 5.27344C13.625 2.36426 11.1032 0 8 0ZM8 7.91016C6.42506 7.91016 5.1875 6.71484 5.1875 5.27344C5.1875 3.82321 6.45309 2.63672 8 2.63672C9.54691 2.63672 10.8125 3.82321 10.8125 5.27344C10.8125 6.70606 9.59372 7.91016 8 7.91016Z"
      fill="#FD003A"
    />
    <Path
      d="M8 0V2.63672C9.54691 2.63672 10.8125 3.82321 10.8125 5.27344C10.8125 6.70605 9.59372 7.91016 8 7.91016V14.9997C8.15997 15.0032 8.32447 14.9313 8.41562 14.7837L12.8281 7.97168C13.3531 7.16312 13.625 6.22269 13.625 5.27344C13.625 2.36426 11.1032 0 8 0Z"
      fill="#E50027"
    />
  </Svg>
);

export default LocationIcon;
